/**
 * Este archivo incluye polyfills necesarios para Angular y se carga antes de la aplicación.
 */

import 'zone.js';  // Incluido con Angular CLI.
